import { ChangeDetectionStrategy, Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'

export interface WarningMessageDialogData {
  title: string
  message: string;
}

@Component({
  templateUrl: './warning-message-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WarningMessageDialogComponent {
  public message?: string

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: WarningMessageDialogData,
  ) { }
}
